var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showMainList && !_vm.showPriceCombinationStep,
              expression: "showMainList && !showPriceCombinationStep"
            }
          ],
          staticClass: "main-content",
          attrs: { type: "primary" }
        },
        [
          _c(
            "fcl-search-bar",
            {
              attrs: {
                "is-show-created-by": true,
                "is-show-sale-state": true,
                "is-query": true,
                "is-query-price": true,
                "show-currency": true,
                "show-price-no": true,
                "is-surcharge": true,
                "is-show-contract-no": true,
                filter: _vm.filter,
                "config-id": "FclRealList" + _vm.configModule
              },
              on: {
                onLevelChanged: _vm.onLevelChanged,
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemResetCallBack: _vm.toAdvancedQuery,
                onGridRefresh: _vm.gridRefresh,
                reset: function($event) {
                  _vm.rowData = []
                }
              }
            },
            [
              _c(
                "template",
                { slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "quotation", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.onQuotation()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Pricing.Quotation")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "subscribe", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.onSubscribe()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Pricing.Subscribe")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "export", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.exportToExcel()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Pricing.Export")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "combinationPlanQuery", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.showPriceCombinationStep = true
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_CombinationPlanQuery"))
                      )
                    ]
                  ),
                  _c("span", { staticStyle: { "margin-left": "20px" } }, [
                    _vm._v(_vm._s(_vm.globalMsg))
                  ])
                ],
                1
              )
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  "config-module": _vm.configModule,
                  "grid-params": _vm.gridParams,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  "export-file-name": _vm.priceUtil.getFileName("PriceFCL")
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              ref: "txtRemark",
              staticStyle: { height: "6%", width: "99%" },
              on: {
                dblclick: function($event) {
                  return _vm.onTxtRemarksDoubleClick()
                }
              }
            },
            [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.txtRemarks,
                    expression: "txtRemarks"
                  }
                ],
                staticStyle: {
                  width: "100%",
                  "margin-left": "10px",
                  height: "100%"
                },
                attrs: {
                  no: "txtRemark",
                  disabled: true,
                  title: _vm.$t("Pricing.RemarkAreaToolTip")
                },
                domProps: { value: _vm.txtRemarks },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.txtRemarks = $event.target.value
                  }
                }
              })
            ]
          )
        ],
        1
      ),
      _vm.subscribe.visible
        ? _c("subscribe-dialog", {
            attrs: {
              visible: _vm.subscribe.visible,
              "local-email": _vm.subscribe.localEmail
            },
            on: {
              close: _vm.onSubscribeClose,
              saveLocalEmail: function(p) {
                _vm.subscribe.localEmail = p
              }
            }
          })
        : _vm._e(),
      _vm.priceDialog.visible
        ? _c("price-dialog", {
            attrs: {
              visible: _vm.priceDialog.visible,
              price: _vm.priceDialog.price,
              "price-addon": _vm.priceDialog.priceAddon,
              "is-dangerous": _vm.priceDialog.isDangerous,
              "un-no": _vm.priceDialog.unNo,
              "etd-date": _vm.priceDialog.etdDate,
              level: _vm.priceDialog.level
            },
            on: { close: _vm.onPriceDialogClose }
          })
        : _vm._e(),
      _vm.quotationDetail.visible
        ? _c("quotation-detail-dialog", {
            attrs: {
              visible: _vm.quotationDetail.visible,
              model: _vm.quotationDetail.quotation,
              editing: _vm.quotationDetail.isEditing,
              "show-quotation-detail": _vm.quotationDetail.showDetail
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.quotationDetail, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.showPriceCombinationStep
        ? _c("price-combination-step", {
            attrs: {
              type: _vm.SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code
            },
            on: {
              back: function($event) {
                _vm.showPriceCombinationStep = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }